export type AnalyticsDataLayerEntry = {
  category: string;
  action: string;
  label: string;
};

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

/**
 * @name sendToAnalytics
 * @param {AnalyticsDataLayerEntry} data
 * @return {void}
 */
export function sendToAnalytics(data: AnalyticsDataLayerEntry) {
  const dataLayer = Array.isArray(window ?? globalThis)
    ? (window ?? globalThis).dataLayer
    : false;
  try {
    if (dataLayer) {
      window?.dataLayer.push(data);
    }
  } catch (e) {
    console.log(e);
  }
}
